// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1MQ-h","text":"SelectPayment_text__2AuM4","title":"SelectPayment_title__3QBqo","btn":"SelectPayment_btn__2wgW7"};